<template>
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--上级分类-->
      <el-form-item label="分类" prop="parentsVal" :label-width="formLabelWidth">
        <el-cascader size="small" v-model="parentsVal" :options="cateList" :props="propsParam" @change="handleChange" v-if="cateList.length>0"></el-cascader>
        <p class="gray9" v-else>暂无</p>
      </el-form-item>

      <el-form-item label="答题" prop="content" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="formData.content" :rows="20" placeholder="导入格式如下：
1.【单选】当大脑处于清醒和警觉状态时，脑电波主要是（    ）
A.α波           	
B.β波            
C.γ波           	
D.δ波
【答案】:B
【分值】:2
【解析】:当大脑处于清醒和警觉状态时，脑电波主要是β波。

2.【多选】下列不属于个性心理的是（	）
A.动机	
B.认知		
C.能力	
D.气质
【答案】:BC
【分值】:2
【解析】:个性心理主要包括个性心理倾向和个性心理特征两个方面。个性心理倾向主要表现包括需 要、动机、兴趣、理想、价值观、人生观和世界观等；个性心理特征主要包括能力、气质和性格。"></el-input>
        <!-- <p class="red">注：保留两个空行结束</p> -->
      </el-form-item>

    <el-form-item label="模版下载" prop="content" :label-width="formLabelWidth">
      <a href="http://zx-jiaoyu.oss-cn-shenzhen.aliyuncs.com/question_template.docx" target="_blank">下载模版</a>
    </el-form-item>

    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>

  </div>
</template>

<script>
import QuestionLibraryApi from '@/api/study/question_library.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        content: '',
        type: 10,
      },
      /*验证规则*/
      formRules: {
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      /*当前父集ID*/
      parentsVal: [],
      /*分类列表*/
      // cateList: [],
      /*排序*/
      srot: '1',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*展示数据*/
      propsParam: {
        label: 'name',
        value: 'category_id',
        // checkStrictly: true
      },
    };
  },
  props: ['open_import', 'cateList', 'category_ids', 'type'],
  created() {
    this.dialogVisible = this.open_import;
    this.parentsVal = this.category_ids;
    this.formData.type = this.type;
  },
  methods: {
    /*选择分类*/
    handleChange(e) {
    },
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      params.category_ids = self.parentsVal.length>0 ? self.parentsVal : [];
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          QuestionLibraryApi.import(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/study/questionlibrary/part/Import.vue